function getNative(e,i){var t=null==e?void 0:e[i];return isNative(t)?t:void 0}var isNative=require("../lang/isNative");module.exports=getNative;